function normalizeBaseUrl(value) {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim().replace(/\/+$/, '');
}

export function resolveApiBaseUrl({ envUrl, windowObject } = {}) {
  const configured = normalizeBaseUrl(envUrl ?? process.env.REACT_APP_BACKEND_URL);
  if (configured) {
    return configured;
  }

  const location = windowObject === undefined
    ? (typeof window !== 'undefined' ? window.location : null)
    : windowObject?.location ?? null;
  if (location?.origin) {
    return `${location.origin}/api/v1`;
  }

  return '/api/v1';
}

export const API_BASE_URL = resolveApiBaseUrl();
export const TENANT_SLUG = (process.env.REACT_APP_TENANT_SLUG || '').trim();
